import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { chatAxios, aiServiceAxios } from "../../../utils/aiService"
import type { SessionInfo } from "../types"

export const chatQueries = {
  all: ["chat"] as const,
  sessions: () => [...chatQueries.all, "sessions"] as const,
  session: (sessionId: string) =>
    [...chatQueries.all, "session", sessionId] as const,
  messages: (sessionId: string) =>
    [...chatQueries.session(sessionId), "messages"] as const,
}

export const useSessions = () => {
  return useQuery({
    queryKey: [...chatQueries.sessions()],
    queryFn: async () => {
      const response = await chatAxios.get<SessionInfo[]>("/api/ai/sessions/")

      if (response.status !== 200) return []
      const data = response.data satisfies SessionInfo[]

      return data
    },
  })
}

export const useDeleteSession = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (sessionId: string) => {
      await aiServiceAxios.delete(`/api/ai/sessions/${sessionId}/`)
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: chatQueries.sessions() })
    },
  })
}

export const useCreateSession = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async ({ title }: { title: string }) => {
      const { data } = await aiServiceAxios.post<SessionInfo>("/api/chats/", {
        title,
      })
      return data
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: chatQueries.sessions() })
    },
  })
}
